import { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import categoryService from "../../services/CategoryService";

export default function CategoryEditPage() {
    const [mounted, setMounted] = useState(false);
    useEffect(() => { setMounted(true); }, []);
  const { id } = useParams();
  const navigate = useNavigate();
  const toast = useRef(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [category, setCategory] = useState({
    id: 0,
    name: "",
    description: "",
  });

  useEffect(() => {
    loadCategory();
  }, []);

  const loadCategory = async () => {
    try {
      setLoading(true);
      const res = await categoryService.getById(id);
      const data = res.data.data || res.data;
      setCategory({
        id: data.id,
        name: data.name,
        description: data.description,
      });
    } catch (err) {
      toast.current.show({
        severity: "error",
        summary: "Hata",
        detail: "Kategori yüklenirken hata oluştu",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    if (!category.name.trim()) {
        toast.current.show({ severity: 'warn', summary: 'Uyarı', detail: 'Kategori adı boş olamaz!' });
        return;
    }

    try {
      setSaving(true);
      await categoryService.update(category);
      toast.current.show({
        severity: "success",
        summary: "Başarılı",
        detail: "Kategori başarıyla güncellendi",
      });
      setTimeout(() => navigate("/categories"), 700);
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Hata",
        detail: "Kategori güncellenemedi",
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="p-2 md:p-4 animate-fade-in bg-[#f8fafc] min-h-screen">
      <Toast ref={toast}  appendTo={mounted ? document.body : "self"} />

      <div className="max-w-3xl mx-auto">
        <div className="bg-white shadow-lg shadow-slate-200/50 border border-slate-200 rounded-2xl overflow-hidden">
          {/* Header */}
          <div className="bg-slate-50/50 border-b border-slate-200 p-4 md:p-6 flex items-center justify-between">
            <div className="flex items-center gap-4">
              <div className="bg-emerald-600 p-3 rounded-xl shadow-md shadow-emerald-500/20">
                <i className="pi pi-pencil text-white text-xl"></i>
              </div>
              <div>
                <h1 className="text-xl md:text-2xl font-black text-slate-900 uppercase tracking-tight">Kategori Düzenle</h1>
                <div className="flex items-center gap-2 mt-0.5">
                  <span className="px-2 py-0.5 bg-emerald-50 text-emerald-600 text-[9px] font-black rounded-lg uppercase border border-emerald-100">GÜNCELLE</span>
                  <span className="text-slate-400 text-xs font-medium">• Kategori bilgilerini düzenleyin</span>
                </div>
              </div>
            </div>

            <div className="flex gap-2">
              <Button
                label="GERİ"
                icon="pi pi-arrow-left"
                className="p-button-text text-slate-400 font-black text-sm hover:bg-slate-100 rounded-xl px-4 py-2"
                onClick={() => navigate("/categories")}
              />
              <Button
                label="GÜNCELLE"
                icon="pi pi-save"
                loading={saving}
                className="!bg-emerald-600 border-none hover:!bg-emerald-700 rounded-xl px-6 py-3 font-black text-sm shadow-lg !shadow-emerald-600/20 transition-all hover:scale-[1.02]"
                onClick={handleSave}
              />
            </div>
          </div>

          {/* Form Content */}
          <div className="p-6 md:p-8 space-y-6">
            {loading ? (
                <div className="flex justify-center py-10">
                    <i className="pi pi-spin pi-spinner text-3xl text-emerald-600"></i>
                </div>
            ) : (
                <div className="grid grid-cols-1 gap-6">
                <div className="space-y-2">
                    <label className="text-[10px] text-slate-400 font-black uppercase tracking-wider block ml-1">Kategori Adı</label>
                    <InputText
                    value={category.name}
                    placeholder="Kategori adı..."
                    className="w-full border-slate-200 rounded-xl focus:border-emerald-500 py-3 shadow-sm font-bold text-base"
                    onChange={(e) => setCategory({ ...category, name: e.target.value })}
                    />
                </div>

                <div className="space-y-2">
                    <label className="text-[10px] text-slate-400 font-black uppercase tracking-wider block ml-1">Açıklama</label>
                    <InputTextarea
                    value={category.description}
                    placeholder="Açıklama..."
                    rows={4}
                    className="w-full border-slate-200 rounded-xl focus:border-emerald-500 py-3 shadow-sm font-medium"
                    onChange={(e) => setCategory({ ...category, description: e.target.value })}
                    />
                </div>
                </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
